import { render } from "./IngresosDetalle.vue?vue&type=template&id=2e8b7de8&scoped=true"
import script from "./IngresosDetalle.vue?vue&type=script&lang=js"
export * from "./IngresosDetalle.vue?vue&type=script&lang=js"

import "./IngresosDetalle.vue?vue&type=style&index=0&id=2e8b7de8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8b7de8"]])

export default __exports__